// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

import '@/style/reset.less'
import '@/style/common.less'
import '@/style/main.less'
import VConsole from 'vconsole';

import Mint from 'mint-ui'
import 'mint-ui/lib/style.css'
Vue.use(Mint)
Vue.prototype.$createPlayer = (options) => new Aliplayer(options);
// new VConsole();

Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  mounted() {
    document.documentElement.style.fontSize = document.documentElement.clientWidth / 7.5 + 'px'
    window.addEventListener('resize', function () {
      document.documentElement.style.fontSize = document.documentElement.clientWidth / 7.5 + 'px'
    })
  },
  template: '<App/>'
})

setTimeout(() => {
  if (window.CP && typeof window.CP.ready === "function") {
    window.CP.ready({
      debug: false, // 是否是开启调试模式
      wxOption: {
        debug: false, //是否是开启调试模式
        redirect:
          window.location.href.split("#")[0] +
          "#" +
          window.location.href.split("#")[1], //回调域名
        jsApiList: []
      },
      ready(client_info) {
        // eslint-disable-next-line camelcase
        window.$clientInfo = client_info;
      },
      error(error) {
        console.log(error);
      }
    });
  }
}, 500)



// WEBPACK FOOTER //
// ./src/main.js